const movieSelector = (state) => state.movies

export { movieSelector }